import styled, { css, keyframes } from 'styled-components';

export const ChartTitle = styled.div`
  font-size: 0.75rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
  font-weight: 500;
`;

export const ChartWrapper = styled.div<{ $height?: number }>`
  height: ${({ $height }) => $height ?? 250}px;
  width: 100%;
`;

const shimmerMove = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position:  400px 0; }
`;

const shimmerBase = css`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 800px 100%;
  animation: ${shimmerMove} 1.4s ease-in-out infinite;
`;

export const ShimmerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  max-width: 100%;
  padding: 0.25rem 0;
`;

export const TitleLine = styled.div`
  height: 0.875rem;
  width: 45%;
  border-radius: 0.25rem;
  ${shimmerBase}
`;

export const ChartArea = styled.div`
  height: 200px;
  width: 100%;
  border-radius: 0.5rem;
  ${shimmerBase}
`;
